import script from "./QuoteView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteView.vue?vue&type=script&setup=true&lang=js"

import "./QuoteView.vue?vue&type=style&index=0&id=348696e4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348696e4"]])

export default __exports__